// extracted by mini-css-extract-plugin
export default {"root":"EmptyMessage__root--lc-DAvqb","root_sccom":"EmptyMessage__root_sccom--lc-bcrUi"};